import type { ProjectResponse } from '@/lib/api'

export function buildProjectNumberMap(projects: ProjectResponse[] | undefined): Map<number, number> {
  const ordered = [...(projects ?? [])].sort((a, b) => {
    const createdDiff = new Date(a.created_at).getTime() - new Date(b.created_at).getTime()
    return createdDiff || a.id - b.id
  })
  return new Map(ordered.map((project, index) => [project.id, index + 1]))
}

export function projectLabel(
  project: Pick<ProjectResponse, 'id' | 'name'>,
  numbers?: Map<number, number>,
): string {
  const name = project.name?.trim()
  if (name && !/^(?:Проект|Project)\s*#?\s*\d+$/i.test(name)) return name
  const number = numbers?.get(project.id)
  return number ? `Проект #${number}` : 'Проект'
}

export function projectLabelById(
  projectId: number,
  projects: ProjectResponse[] | undefined,
  numbers?: Map<number, number>,
): string {
  const project = projects?.find((item) => item.id === projectId)
  if (project) return projectLabel(project, numbers)
  const number = numbers?.get(projectId)
  return number ? `Проект #${number}` : 'Проект'
}
